import { RestService } from './ResyService';
import { Inverter, Manageinverter } from '@/models';
import { InverterEndPoints } from './config';

export class InverterService extends RestService {


    postInverter(data: Inverter) {
        const body = JSON.stringify({
            'serial_id': data.serial_id,
            'company_id': data.company_id,
            'max_power': data.max_power
        })
        return this.post(InverterEndPoints.AddInverter, body);
    }

    saveManagedInverter(data: Manageinverter) {
        const body = JSON.stringify(data);
        return this.post(InverterEndPoints.ManageInverter, body);
    }
    saveInverter(data) {
        const body = JSON.stringify({
            "description": data.inverterDescription,
            "serial_id": data.inverterSerialID,
            "dc_power":data.dc_power
        });
        return this.post(InverterEndPoints.InvertersEdit, body);
    }
    updateInverter(data) {
        const body = JSON.stringify({
            "serial_id": data.inv_serial_id,
            "inv_serial_id": data.serial_id,
            "company_serial_id": data.company_serialid,
            "max_power": data.max_power
        });
        // console.log(body)
        // return true
        return this.post(InverterEndPoints.InvertersEdit, body);
    }
    updateInverterMpptStrings(id, data) {
        const body = JSON.stringify({
            inverter_id: id,
            data: data
        })
        return this.post(InverterEndPoints.mpptPost, body);
    }
    deleteInverter() {
        return this.delete(InverterEndPoints.Delete)
    }
    getInverterCompany() {
        return this.get(InverterEndPoints.InverterCompany);
    }
    getInverterMpptStrings(inverterID) {
        return this.get(InverterEndPoints.mpptGet + '?inverter_id=' + inverterID);
    }
    getAllInverters() {
        return this.get(InverterEndPoints.Inverters)
    }
    getInverterById(id: number) {
        return this.get(InverterEndPoints.Inverters + '/' + id);
    }
    getInverterCompanyById(id: number) {
        return this.get(InverterEndPoints.InverterCompanyDetail + id);
    }
}